var _path, _g, _g2, _g3, _g4, _path2, _path3, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2963 174.78C138.625 174.78 171.317 142.088 171.317 101.759C171.317 61.4309 138.625 28.7383 98.2963 28.7383C57.968 28.7383 25.2754 61.4309 25.2754 101.759C25.2754 142.088 57.968 174.78 98.2963 174.78Z",
    fill: "url(#paint0_linear_434_11183)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_434_11183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.88 33H124.631C122.849 33 121.404 34.4449 121.404 36.2272V54.2049C121.404 55.9872 122.849 57.4321 124.631 57.4321H162.88C164.662 57.4321 166.107 55.9872 166.107 54.2049V36.2272C166.107 34.4449 164.662 33 162.88 33Z",
    fill: "url(#paint1_linear_434_11183)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "path-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.845 48.9282C132.894 48.9282 134.555 47.2671 134.555 45.218C134.555 43.1689 132.894 41.5078 130.845 41.5078C128.796 41.5078 127.135 43.1689 127.135 45.218C127.135 47.2671 128.796 48.9282 130.845 48.9282Z",
    fill: "#393ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.104 48.9282C146.153 48.9282 147.814 47.2671 147.814 45.218C147.814 43.1689 146.153 41.5078 144.104 41.5078C142.055 41.5078 140.394 43.1689 140.394 45.218C140.394 47.2671 142.055 48.9282 144.104 48.9282Z",
    fill: "#393ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.364 48.9282C159.413 48.9282 161.074 47.2671 161.074 45.218C161.074 43.1689 159.413 41.5078 157.364 41.5078C155.314 41.5078 153.653 43.1689 153.653 45.218C153.653 47.2671 155.314 48.9282 157.364 48.9282Z",
    fill: "#393ABD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_434_11183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4482 127.103C57.4482 142.904 75.7838 147 97.5 147C119.101 147 137.552 143.049 137.552 127.242C137.552 111.44 119.221 107.345 97.5 107.345C75.899 107.345 57.4482 111.295 57.4482 127.103Z",
    fill: "url(#empty-state-register-guest-linear-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.293 101.793C111.282 101.793 121.69 91.3804 121.69 78.3943C121.69 65.4083 111.282 55 98.293 55C85.3082 55 74.8965 65.4083 74.8965 78.3943C74.8965 91.3804 85.3082 101.793 98.293 101.793Z",
    fill: "url(#empty-state-register-guest-linear-2)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "path-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3577 155.611C91.8752 153.467 94.9249 153.467 95.4424 155.611L95.6997 156.677C95.8847 157.443 96.4829 158.041 97.2491 158.226L98.3149 158.484C100.459 159.001 100.459 162.051 98.3149 162.568L97.2491 162.826C96.4829 163.011 95.8847 163.609 95.6997 164.375L95.4424 165.441C94.9249 167.585 91.8752 167.585 91.3577 165.441L91.1004 164.375C90.9154 163.609 90.3172 163.011 89.551 162.826L88.4851 162.568C86.3411 162.051 86.3411 159.001 88.4851 158.484L89.551 158.226C90.3172 158.041 90.9154 157.443 91.1004 156.677L91.3577 155.611Z",
    fill: "url(#paint4_linear_434_11183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5178 33.3807C39.0354 31.2366 42.085 31.2366 42.6026 33.3807L42.8599 34.4465C43.0448 35.2127 43.643 35.8109 44.4092 35.9959L45.4751 36.2532C47.6191 36.7707 47.6191 39.8204 45.4751 40.3379L44.4092 40.5952C43.643 40.7802 43.0448 41.3784 42.8599 42.1446L42.6026 43.2104C42.085 45.3545 39.0354 45.3545 38.5178 43.2104L38.2605 42.1446C38.0756 41.3784 37.4774 40.7802 36.7112 40.5952L35.6453 40.3379C33.5013 39.8204 33.5013 36.7707 35.6453 36.2532L36.7112 35.9959C37.4774 35.8109 38.0756 35.2127 38.2605 34.4465L38.5178 33.3807Z",
    fill: "url(#paint5_linear_434_11183)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3846 31.0504C96.6158 31.0504 97.6139 30.0523 97.6139 28.8211C97.6139 27.59 96.6158 26.5919 95.3846 26.5919C94.1534 26.5919 93.1554 27.59 93.1554 28.8211C93.1554 30.0523 94.1534 31.0504 95.3846 31.0504ZM95.3846 32.7224C97.5392 32.7224 99.2858 30.9757 99.2858 28.8211C99.2858 26.6666 97.5392 24.9199 95.3846 24.9199C93.23 24.9199 91.4834 26.6666 91.4834 28.8211C91.4834 30.9757 93.23 32.7224 95.3846 32.7224Z",
    fill: "url(#paint6_linear_434_11183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.976 93.5049C164.643 92.1989 165.849 91.0221 167.146 91.3868L170.6 92.3574C171.898 92.722 172.314 94.3546 171.35 95.296L168.782 97.802C167.817 98.7434 166.195 98.2876 165.862 96.9815L164.976 93.5049Z",
    fill: "url(#paint7_linear_434_11183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9353 83.1354C34.2417 82.8041 35.4169 84.0113 35.0506 85.3084L34.0755 88.7612C33.7092 90.0583 32.0761 90.4724 31.1359 89.5066L28.6333 86.9357C27.6931 85.97 28.151 84.3486 29.4575 84.0173L32.9353 83.1354Z",
    fill: "url(#paint8_linear_434_11183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.251 160.163C140.557 159.831 141.732 161.039 141.366 162.336L140.391 165.789C140.025 167.086 138.392 167.5 137.451 166.534L134.949 163.963C134.009 162.997 134.466 161.376 135.773 161.045L139.251 160.163Z",
    fill: "url(#paint9_linear_434_11183)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.869 66.1305C171.1 66.1305 172.098 65.1324 172.098 63.9012C172.098 62.67 171.1 61.672 169.869 61.672C168.638 61.672 167.64 62.67 167.64 63.9012C167.64 65.1324 168.638 66.1305 169.869 66.1305ZM169.869 67.8024C172.024 67.8024 173.77 66.0558 173.77 63.9012C173.77 61.7466 172.024 60 169.869 60C167.714 60 165.968 61.7466 165.968 63.9012C165.968 66.0558 167.714 67.8024 169.869 67.8024Z",
    fill: "url(#paint10_linear_434_11183)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.006 154.945L163.538 144.45L190.405 168.79L190.404 168.791L191.839 170.091C193.232 171.353 194.066 173.115 194.157 174.992C194.249 176.868 193.59 178.703 192.327 180.094C191.063 181.486 189.298 182.319 187.42 182.41C185.541 182.501 183.703 181.844 182.31 180.582L180.876 179.282L180.873 179.285L154.006 154.945Z",
    fill: "url(#paint11_linear_434_11183)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.611 126.755C173.611 148.712 155.789 166.511 133.805 166.511C111.822 166.511 94 148.712 94 126.755C94 104.799 111.822 87 133.805 87C155.789 87 173.611 104.799 173.611 126.755ZM167.505 126.755C167.505 145.343 152.417 160.412 133.805 160.412C115.193 160.412 100.105 145.343 100.105 126.755C100.105 108.167 115.193 93.0977 133.805 93.0977C152.417 93.0977 167.505 108.167 167.505 126.755Z",
    fill: "url(#paint12_linear_434_11183)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_434_11183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.805 160.416C152.417 160.416 167.505 145.347 167.505 126.759C167.505 108.17 152.417 93.1016 133.805 93.1016C115.193 93.1016 100.105 108.17 100.105 126.759C100.105 145.347 115.193 160.416 133.805 160.416Z",
    fill: "url(#paint13_linear_434_11183)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_434_11183",
    x: 85.1055,
    y: 78.1016,
    width: 97.3994,
    height: 97.3145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_434_11183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_434_11183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_11183",
    x1: 97.7334,
    y1: 4.96087,
    x2: 99.2293,
    y2: 261.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_11183",
    x1: 120.062,
    y1: 51.3211,
    x2: 202.995,
    y2: 67.9283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state-register-guest-linear-1",
    x1: 60.9473,
    y1: 199.708,
    x2: 141.634,
    y2: 197.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-one",
    stopColor: "#6263D0"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-two",
    offset: 1,
    stopColor: "#393ABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state-register-guest-linear-2",
    x1: 76.9405,
    y1: 163.989,
    x2: 124.112,
    y2: 163.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-one",
    stopColor: "#6263D0"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-two",
    offset: 1,
    stopColor: "#393ABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_11183",
    x1: 87.4028,
    y1: 161.921,
    x2: 101.92,
    y2: 165.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_11183",
    x1: 34.5629,
    y1: 39.6902,
    x2: 49.0805,
    y2: 43.4734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_434_11183",
    x1: 93.6354,
    y1: 29.2279,
    x2: 97.8697,
    y2: 30.3314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_434_11183",
    x1: 166.737,
    y1: 96.716,
    x2: 172.167,
    y2: 93.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_434_11183",
    x1: 29.7219,
    y1: 84.8922,
    x2: 32.8118,
    y2: 90.3262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_434_11183",
    x1: 136.037,
    y1: 161.92,
    x2: 139.127,
    y2: 167.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_434_11183",
    x1: 168.12,
    y1: 64.308,
    x2: 172.354,
    y2: 65.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_434_11183",
    x1: 160.196,
    y1: 160.574,
    x2: 169.804,
    y2: 150.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8788B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_434_11183",
    x1: 93.9098,
    y1: 105.35,
    x2: 174.044,
    y2: 105.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8485B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_434_11183",
    x1: 133.805,
    y1: 93.1016,
    x2: 167.689,
    y2: 181.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.1e98f97b1ac333a75bca0d317b92bea2.svg";
export { ForwardRef as ReactComponent };